// src/api/api_main.js
import smartApi from './smart';

// Add more APIs here later
const apis = {
  smart: smartApi,
  // another: anotherApi,
};

export default async function apiMain(apiName, actionKey, params = {}) {
  if (!apis[apiName]) {
    return { state: false, data: null, message: `API "${apiName}" not found` };
  }

  return await apis[apiName](actionKey, params);
}
